import React, { createContext, ReactNode, useContext, useState } from "react"
interface GlobalQuickSignUpModalStateProps {
  children: ReactNode
}

interface QuickSignUpContextType {
  showFastSignUpPopUp: boolean
  setShowFastSignUpPopUp: React.Dispatch<React.SetStateAction<boolean>>
  fastSignUpStage: "progress" | "done"
  setFastSignUpStage: React.Dispatch<React.SetStateAction<"progress" | "done">>
  eventParams: {
    plusOneCount: number
  }
  setEventParams: React.Dispatch<React.SetStateAction<{ plusOneCount: number }>>
}

const QuickSignUpContext = createContext<QuickSignUpContextType | undefined>(
  undefined,
)

export const useSignUpModalState = (): QuickSignUpContextType => {
  const context = useContext(QuickSignUpContext)
  if (!context) {
    throw new Error("useImageModal must be used within an GlobalImageModal")
  }
  return context
}

const GlobalQuickSignUpModalState: React.FC<
  GlobalQuickSignUpModalStateProps
> = ({ children }) => {
  const [showFastSignUpPopUp, setShowFastSignUpPopUp] = useState(false)
  const [fastSignUpStage, setFastSignUpStage] = useState<"progress" | "done">(
    "progress",
  )
  const [eventParams, setEventParams] = useState<{ plusOneCount: number }>({
    plusOneCount: 0,
  })

  return (
    <QuickSignUpContext.Provider
      value={{
        showFastSignUpPopUp,
        setShowFastSignUpPopUp,
        fastSignUpStage,
        setFastSignUpStage,
        eventParams,
        setEventParams,
      }}
    >
      {children}
    </QuickSignUpContext.Provider>
  )
}

export default GlobalQuickSignUpModalState
